import { useEffect, useState } from 'react';

// material-ui
import { Grid } from '@mui/material';
import { gridSpacing } from 'store/constant';
import { getApi } from 'views/services/api';
import TotalCustomersCard from './TotalCustomers';
import TotalReservationCard from './TotalReseravtions';
import { useNavigate } from 'react-router';
import TotalHotelsCard from './TotalHotels';
import HotelManagement from 'views/HotelManagement';
import TotalRooms from './TotalRooms';

const AdminDashboard = () => {
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(false);
  }, []);

  const [hotelData, sethotelData] = useState(0);
  const [reservationData, setreservationData] = useState(0);
  const [customerData, setcustomerData] = useState(0);
  const [roomData, setRoomData] = useState(0);

  // function for fetching all the hotels data from the db

  const fetchhotelData = async () => {
    try {
      const response = await getApi(`api/hotel/viewallhotels`);
      sethotelData(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchReservationData = async () => {
    try {
      const response = await getApi(`api/reservation/viewallreservation`);
      console.log("response : ",response);
      
      setreservationData(response?.data?.reservationData);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchcustomerData = async () => {
    try {
      const response = await getApi(`api/customer/viewallcustomer`);
      console.log("response : ",response);
      
      setcustomerData(response?.data?.customerData);
    } catch (error) {
      console.log(error);
    }
  };

  // // function for fetching all the restaurant items data from the db
  const fetchRoomData = async () => {
    try {
      const response = await getApi(`api/room/viewallrooms`);

      setRoomData(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchhotelData();
    fetchReservationData();
    fetchcustomerData();
    fetchRoomData();
  }, []);

  return (
    <>
      <Grid container spacing={gridSpacing}>
        <Grid item xs={12}>
          <Grid container spacing={gridSpacing}>
            <Grid
              item
              lg={3}
              md={6}
              sm={6}
              xs={12}
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                navigate('/dashboard/hotel');
              }}
            >
              <TotalHotelsCard isLoading={isLoading} hotelData={hotelData} />
            </Grid>
            <Grid item lg={3} md={6} sm={6} xs={12}>
              <TotalCustomersCard isLoading={isLoading} customerData={customerData} />
            </Grid>
            <Grid item sm={6} xs={12} md={6} lg={3}>
              <TotalRooms isLoading={isLoading} roomData={roomData} />
            </Grid>

            <Grid item sm={6} xs={12} md={6} lg={3}>
              <TotalReservationCard isLoading={isLoading} reservationData={reservationData} />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <HotelManagement />
        </Grid>
      </Grid>
    </>
  );
};

export default AdminDashboard;
